import { useEffect, useState } from 'react';

import './App.scss';
import { Routes, Route, useLocation, Link, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import Home from './pages/Home';
import Project from './pages/Project';
import Categories from './pages/Categories';
import Info from './pages/Info';
import LanguageButton from './components/LanguageButton';

import client from './cmsClient.js';
import { useLanguage } from './contexts/LanguageContext';
import Menu from './components/Menu.jsx';
import PageTransition from './utils/motionPageTransition';

// import Informations from './components/Informations.jsx';

function App() {
  const [slider, setSlider] = useState({});
  const [projects, setProjects] = useState([]);
  const [informations, setInformations] = useState([]);
  const [entrance, setEntrance] = useState([]);
  const { language } = useLanguage();
  const [activeInfoIds, setActiveInfoIds] = useState([]);
  const [, setIsInfoExpanded] = useState(false);
  const [categories, setCategories] = useState([]);

  const [showInfo, setShowInfo] = useState(false);
  const [showTypes, setShowTypes] = useState(false);
  const [selectedType, setSelectedType] = useState(null);
  const location = useLocation();

  const ogImage = 'https://laurephilippe.fr/og-image.jpg';

  const isBioActive = activeInfoIds.includes("41d85557-c540-411f-9eea-dd8a964aac68");
  const hasActiveInfo = activeInfoIds.length > 0;

  useEffect(() => {
    const setVh = () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };
    setVh();
    window.addEventListener("resize", setVh);
    return () => window.removeEventListener("resize", setVh);
  }, []);

  window.addEventListener(
    'contextmenu',
    function (e) {
      e.preventDefault();
    },
    false
  );


  useEffect(() => {
    const fetchProject = async () => {
      try {
        const response = await client.getEntries({
          content_type: 'inSitu',
          locale: language,
          include: 3
        });

        if (response.items.length > 0) {

          //console.log('Fetched all projects:', response.items);
          setProjects(response.items);
          // Default to first project for slider if not already set or as initial
          setSlider(response.items[0].fields);
        }
      } catch (error) {
        console.error('Error fetching Project data:', error);
      }
    };
    fetchProject();
  }, [language]);

  useEffect(() => {
    const fetchCateries = async () => {
      try {
        const response = await client.getEntries({
          content_type: 'categorieProjet',
          locale: language,
          include: 3
        });

        if (response.items.length > 0) {
          //  console.log('Fetched all categories:', response.items);
          setCategories(response.items);
          // Default to first category for slider if not already set or as initial
          setSlider(response.items[0].fields);
        }
      } catch (error) {
        console.error('Error fetching Categories data:', error);
      }
    };
    fetchCateries();
  }, [language]);



  useEffect(() => {
    const fetchInformations = async () => {
      try {
        const response = await client.getEntries({
          content_type: 'informations',
          locale: language,
          include: 3
        });

        if (response.items.length > 0) {
          //console.log('Fetched all informations:', response.items);
          setInformations(response.items);

        }
      } catch (error) {
        console.error('Error fetching Informations data:', error);
      }
    };
    fetchInformations();
  }, [language]);


  useEffect(() => {
    const fetchEntrancePage = async () => {
      try {
        const response = await client.getEntry('3fBeBJyse5IOK0JqdTaUl', {
          include: 3,
          locale: language
        });

        //console.log('Fetched Entrance Page data:', response.fields);
        setEntrance(response.fields);

      } catch (error) {
        console.error('Error fetching Entrance Page data:', error);
      }
    };
    fetchEntrancePage();
  }, [language]);

  return (
    <div className={`App ${hasActiveInfo ? 'info-active' : ''}`}>
      <Helmet>
        {ogImage && <meta property="og:image" content={ogImage} />}
        {ogImage && <meta property="twitter:image" content={ogImage} />}
        {ogImage && <meta itemProp="image" content={ogImage} />}
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="800" />
      </Helmet>
      <LanguageButton />
      <Menu
        projects={projects}
        categories={categories}
        setSlider={setSlider}
        informations={informations}
        setActiveInfoIds={setActiveInfoIds}
        activeInfoIds={activeInfoIds}
        setIsInfoExpanded={setIsInfoExpanded}
        showInfo={showInfo}
        setShowInfo={setShowInfo}
        showTypes={showTypes}
        setShowTypes={setShowTypes}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
      />
      {/*    <Bio texte={entrance?.bio} /> */}
      <AnimatePresence>
        <Routes location={location} key={location.pathname}>
          <Route
            path="/"
            element={
              <PageTransition>
                <Home
                  slider={slider}
                  entrance={entrance}
                  activeInfoIds={activeInfoIds}
                  setActiveInfoIds={setActiveInfoIds}
                  setShowInfo={setShowInfo}
                />
              </PageTransition>
            }
          />
          {categories.map((cat, idx) => (
            <Route
              key={`cat-${idx}`}
              path={`/${cat.fields.url}`}
              element={
                <PageTransition>
                  <Categories
                    category={cat}
                    activeInfoIds={activeInfoIds}
                    setActiveInfoIds={setActiveInfoIds}
                    setShowInfo={setShowInfo}
                  />
                </PageTransition>
              }
            />
          ))}
          <Route
            path="/:projectUrl"
            element={
              <PageTransition>
                <Project
                  projects={projects}
                  activeInfoIds={activeInfoIds}
                  setActiveInfoIds={setActiveInfoIds}
                  setShowInfo={setShowInfo}
                />
              </PageTransition>
            }
          />
          <Route
            path="/info"
            element={
              <PageTransition>
                <Info
                  informations={informations}
                  activeInfoIds={activeInfoIds}
                  setActiveInfoIds={setActiveInfoIds}
                  setShowInfo={setShowInfo}
                />
              </PageTransition>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AnimatePresence>

      {!isBioActive && (
        <Link
          to="/"
          className="laure-philippe"
          onClick={() => {
            setIsInfoExpanded(false);
            setActiveInfoIds([]);
            setShowInfo(false);
          }}
        >
          <p>Laure Philippe</p>
        </Link>
      )}
    </div>
  );
}

export default App;
